import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue';
import 'emoji-picker-element';
import { EmojiClickEvent } from 'emoji-picker-element/shared';
import { useId } from '~/composables/useUniqueId';
import { Picker } from 'emoji-picker-element';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageEmojiPicker',
  emits: ["emoji"],
  setup(__props, { emit }: { emit: ({
  (e: 'emoji', emoji: string): void;
}), expose: any, slots: any, attrs: any }) {



const emojiPickerRef = ref<Picker | null>(null);
const toggleRef = ref<HTMLButtonElement | null>(null);
const isEmojiPickerExpanded = ref(false);
const emojiPickerId = useId('emojis');
const toggleEmojiPickerId = useId('toggle-emojis');

const handleClickOutside = () => {
  isEmojiPickerExpanded.value = false;
};

const onKeyUp = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    isEmojiPickerExpanded.value = false;
    toggleRef?.value?.focus();
  }
};

const handleEmojiClick = (e: EmojiClickEvent) => {
  if (e.detail.unicode) {
    emit('emoji', e.detail.unicode);
  }
};

onMounted(() => {
  if (emojiPickerRef.value) {
    emojiPickerRef.value.skinToneEmoji = '👍';
    emojiPickerRef.value.addEventListener('emoji-click', handleEmojiClick);
    // @todo: add localization data to emoji picker
    // @see: https://github.com/nolanlawson/emoji-picker-element#internationalization
  }
});

onBeforeUnmount(() => {
  emojiPickerRef.value?.removeEventListener('emoji-click', handleEmojiClick);
});

return { __sfc: true,emit, emojiPickerRef, toggleRef, isEmojiPickerExpanded, emojiPickerId, toggleEmojiPickerId, handleClickOutside, onKeyUp, handleEmojiClick }
}

})